(function () {
  'use strict';

  var STORAGE_KEY = 'sb_popup';

  function getEl(id) { return document.getElementById(id); }

  function isExpired(days) {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return true;
    try {
      var data = JSON.parse(raw);
      if (data.subscribed) return false; // never show again after subscription
      if (!days || days === 0) return false; // never show again if reshow_days = 0
      var elapsed = (Date.now() - data.ts) / 86400000;
      return elapsed >= days;
    } catch (e) {
      return true;
    }
  }

  function store(subscribed) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), subscribed: !!subscribed }));
  }

  function init() {
    var backdrop = getEl('sb-popup-backdrop');
    if (!backdrop) return;
    if (backdrop.dataset.disabled === 'true') return;

    // Page reloaded after a SUCCESSFUL signup: show the success state and stop reshowing.
    if (getEl('sb-popup-posted')) {
      store(true);
      show(backdrop);
      showSuccess(backdrop);
      return;
    }

    // Page reloaded after a FAILED signup: reopen with the error visible so they can retry.
    if (getEl('sb-popup-form-errors')) {
      show(backdrop);
      var errEl = getEl('sb-popup-error');
      var msg   = getEl('sb-popup-form-errors').textContent;
      if (errEl) {
        if (msg) errEl.textContent = msg;
        errEl.style.display = 'block';
      }
      return;
    }

    var delay    = parseInt(backdrop.dataset.delay, 10) || 0;
    var reshow   = parseInt(backdrop.dataset.reshowDays, 10);

    if (!isExpired(reshow)) return;

    setTimeout(function () { show(backdrop); }, delay * 1000);
  }

  function show(backdrop) {
    backdrop.classList.add('sb-popup-backdrop--visible');
    document.body.style.overflow = 'hidden';
    backdrop.setAttribute('aria-hidden', 'false');

    var closeBtn = getEl('sb-popup-close');
    var dismissBtn = getEl('sb-popup-dismiss');
    var form = getEl('sb-popup-form');

    function close() {
      backdrop.classList.remove('sb-popup-backdrop--visible');
      document.body.style.overflow = '';
      backdrop.setAttribute('aria-hidden', 'true');
      store(false);
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (dismissBtn) dismissBtn.addEventListener('click', close);

    // Close on backdrop click
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) close();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    if (form) {
      // Submit natively to Shopify (the {% form 'customer' %} action is /contact with
      // form_type=customer). A real page-navigation POST is accepted and creates the
      // customer; an XHR/fetch POST is blocked by Shopify's bot challenge (HTTP 403),
      // which is why the previous AJAX version always failed. The success and error
      // states are shown after the reload via the #sb-popup-posted / #sb-popup-form-errors
      // markers (see init()).
      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('button[type="submit"]');
        // Defer so we never interfere with the native submission already underway.
        setTimeout(function () {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Subscribing…';
          }
        }, 0);
      });
    }
  }

  function showSuccess(backdrop) {
    var formBody = getEl('sb-popup-form-body');
    var success  = getEl('sb-popup-success');
    if (formBody) formBody.style.display = 'none';
    if (success)  success.style.display  = 'block';

    // Auto-close after 4 seconds
    setTimeout(function () {
      backdrop.classList.remove('sb-popup-backdrop--visible');
      document.body.style.overflow = '';
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
